import { FC, useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "constants/routes";
import { AuthLayout } from "layouts/AuthLayout";
import { ResetPassword } from "features/ResetPassword";
import { CONSTANTS } from "../../constants/constants";
import axios from "axios";
import { getBaseUrl } from "api/client/core/request";

const AuthCallback: FC = () => {
  const navigate = useNavigate();

  const onLogOutNoPermissions = useCallback(() => {
    localStorage.removeItem(CONSTANTS.access_token_key);
    const notAuthorizedMsgId = 1;
    window.location.href = `${getBaseUrl()}/v1/logout?data=${notAuthorizedMsgId}`;
  }, []);

  useEffect(() => {
    (async () => {
      // Assuming the access token is in the URL query parameters for illustration.
      // Adjust based on how your backend sends the token.
      const params = new URLSearchParams(window.location.search);
      const accessToken = params.get("token");
      const refreshToken = params.get("refresh_token");

      if (accessToken) {
        // Store the access token. Here we use localStorage for simplicity.
        localStorage.setItem(CONSTANTS.access_token_key, accessToken);
        if (refreshToken) {
          localStorage.setItem(CONSTANTS.refresh_token_key, refreshToken);
        }

        const response = await axios
          .get(`${getBaseUrl()}/v1/auth/status?group_to_check=taster`)
          .catch((e) => {
            console.log("API error", e);
          });

        if (response?.data?.in_group === false) {
          onLogOutNoPermissions();
          return;
        }
        // Redirect to a protected route or homepage after login.
        navigate(ROUTES.home);
      } else {
        // Handle error or redirect back to the login page.
        navigate(ROUTES.home);
      }
    })();
  }, [navigate]);

  return <div>Loading...</div>;
};

export default AuthCallback;
